// Description: Accessibility functions.

/**
 * Sets up the accessibility options.
 */
const setupAccessibility = () => {
    const outerWrapper = document.body;
    const currentColorSwatch = getCookie("rtColorSwatch");
    const currentTextSize = getCookie("rtTextSize");
    const colorSwatchPrefix = "colorswatch-";
    const textSizePrefix = "textsize-";

    removeClassByPrefix(outerWrapper, colorSwatchPrefix);
    removeClassByPrefix(outerWrapper, textSizePrefix);

    /**
     * Adds the "active" class to the elements with the specified class name.
     * @param {string} className - The class name.
     */
    const addActiveClass = (className) => {
        document.querySelectorAll(`.accessibility-options--${className}`).forEach(activeOption => {
            activeOption.classList.add("active");
        });
    };

    if (currentColorSwatch) {
        outerWrapper.classList.add(currentColorSwatch);
        addActiveClass(currentColorSwatch.replace(colorSwatchPrefix, ""));
    }

    if (currentTextSize) {
        outerWrapper.classList.add(currentTextSize);
        addActiveClass(currentTextSize.replace(textSizePrefix, ""));
    }

    addClickByClass(".js-open-accessibility-panel", (event) => {
        openPopup('#popupAccessibilityOptions');
    });
};

/**
 * Sets the color swatch preference.
 * @param {string} colorSwatchName - The color swatch name.
 */
const setColorSwatch = (colorSwatchName) => {
    setAccessibilityPreference('colorswatch-', colorSwatchName, 'rtColorSwatch');
};

/**
 * Sets the text size preference.
 * @param {string} textSize - The text size.
 */
const setTextSize = (textSize) => {
    setAccessibilityPreference('textsize-', textSize, 'rtTextSize');
};

/**
 * Sets the accessibility preference.
 * @param {string} prefix - The prefix.
 * @param {string} cookieValue - The cookie value.
 * @param {string} cookieName - The cookie name.
 */
const setAccessibilityPreference = (prefix, cookieValue, cookieName) => {
    const outerWrapper = document.getElementById("outer-wrapper");

    removeClassByPrefix(outerWrapper, prefix);
    setCookie(cookieName, cookieValue);
    location.reload();
};
